import CRUD from '../masterData/genericCRUD'

const route = 'yield_distributions'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function yieldDistributions(instance) {
	return {
		...CRUD(instance, route),

		/**
		* @param {import("axios").AxiosRequestConfig} config
		*/
		getAll: (config = {}) => {
			const startDate = config.startDate ? `minimumDate=${config.startDate}&` : ''
			const endDate = config.endDate ? `maximumDate=${config.endDate}&` : ''
			return instance.get(`${route}?${startDate}${endDate}`, config)
		},

		/**
		 * @param {object} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getYieldDistribution: (body, config = {}) => {
			return instance.post(`${route}`, body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		updateYieldDistribution: (body, config = {}) => {
			return instance.put(`${route}`, body, config)
		}
	}
}
